var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"tab-view",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" 首页")]),(_vm.tabPath!='/dashboard')?_c('el-breadcrumb-item',{attrs:{"to":{ path: _vm.tabPath}}},[_vm._v(_vm._s(_vm.tabName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }